export default __webpack_public_path__ + "static/media/img1-carousel.f12be2de.webp";